<template>
    <div>
        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-checkbox-group
                    v-model="model.vigilancia"
                    :validations="{ required: true }"
                    name="Vigilância em saúde bucal"
                >
                    <rkm-form-checkbox
                        v-for="vigilancia in vigilancias"
                        :key="vigilancia.id"
                        :value="vigilancia.id"
                        class="w-50 m-0"
                        :disabled="model.exportacao"
                    >
                        {{ vigilancia.descricao }}
                    </rkm-form-checkbox>
                </rkm-form-checkbox-group>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
import enumVigilancia from '@/enums/atencao-basica/atendimento-odontologico/vigilancia'

export default {
    data: () => ({
        vigilancias: [
            {
                id: enumVigilancia.ABSCESSO_DENTO_ALVEOLAR,
                descricao: 'Abscesso Dento Alveolar',
            },
            {
                id: enumVigilancia.ALTERACAO_EM_TECIDOS_MOLES,
                descricao: 'Alteração em Tecidos Moles',
            },
            {
                id: enumVigilancia.DOR_DE_DENTE,
                descricao: 'Dor De Dente',
            },
            {
                id: enumVigilancia.FENDAS_FISSURAS_LABIO_PALATAIS,
                descricao: 'Fendas ou Fissuras Lábio Palatais',
            },
            {
                id: enumVigilancia.FLUOROSE_DENTARIA_MODERADA_SEVERA,
                descricao: 'Fluorose Dentária Moderada ou Sevéra',
            },
            {
                id: enumVigilancia.TRAUMATISMO_DENTO_ALVEOLAR,
                descricao: 'Traumatismo Dento Alveolar',
            },
            {
                id: enumVigilancia.NAO_IDENTIFICADO,
                descricao: 'Não Identificado',
            },
        ],
    }),
    props: {
        model: { type: Object, required: false },
    },
};
</script>
